const AgreementsLoading = ['$resource', function ($resource) {
    return $resource(API_URL + '/api/1.0/masters/agreements/');
}]

const AgreementsMaster = ['$q', 'AgreementsLoading',  function ($q, AgreementsLoading) {

    var agreements= {
        items: null,

        loadAgreements: function () {
            var self = this;
            var deferred = $q.defer();
            if (this.items == null)
                AgreementsLoading.query(function (data) {
                    self.items = data;
                    deferred.resolve(data);
                });
            else
                deferred.resolve(self.items);

            return deferred.promise;
        }

    };

    return agreements;
}]


export {AgreementsLoading, AgreementsMaster}

/*
.factory('AgreementsLoading
.service('AgreementsMaster
*/